module.exports = __webpack_public_path__ + "img/run_right.53af303a.jpg";